import {
  IconArrowOpenEndSolid,
  IconArrowOpenStartSolid,
  IconButton,
  IconCalendarAddLine,
  TextInput,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { forwardRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./inputDate.css";

const ExampleCustomInput = forwardRef(
  ({ value, onClick, onChange, onFocus, onBlur, id, label }, ref) => (
    <TextInput
      renderLabel={label}
      placeholder="mm/dd/yyyy"
      value={value}
      id={id}
      onChange={onChange}
      onClick={onClick}
      onFocus={onFocus}
      onBlur={onBlur}
      renderAfterInput={<IconCalendarAddLine />}
      inputRef={ref}
    />
  )
);

export const InputDate = ({ id, label, selectHandler, selectedDate }) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(
    selectedDate ? new Date(selectedDate) : new Date().setHours(0, 0, 0, 0)
  );

  const range = (start, stop, step) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (_, i) => start + i * step
    );

  const years = range(1900, new Date().getFullYear() + 15, 1);
  const months = [
    t("dates.months.january"),
    t("dates.months.february"),
    t("dates.months.march"),
    t("dates.months.april"),
    t("dates.months.may"),
    t("dates.months.june"),
    t("dates.months.july"),
    t("dates.months.august"),
    t("dates.months.september"),
    t("dates.months.october"),
    t("dates.months.november"),
    t("dates.months.december"),
  ];

  const customHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    return (
      <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
        <IconButton
          renderIcon={IconArrowOpenStartSolid}
          size="small"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          withBackground={false}
          withBorder={false}
          screenReaderLabel={t("dates.decreaseMonth")}
          margin="0 xxx-small 0 0"
        />

        <select
          className="selectorStyle"
          aria-label={t("dates.chooseYear")}
          value={new Date(date).getFullYear()}
          onChange={({ target: { value } }) => changeYear(value)}
        >
          {years.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        <select
          className="selectorStyle"
          value={months[new Date(date).getMonth()]}
          aria-label={t("dates.chooseMonth")}
          onChange={({ target: { value } }) =>
            changeMonth(months.indexOf(value))
          }
        >
          {months.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        <IconButton
          renderIcon={IconArrowOpenEndSolid}
          size="small"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          withBackground={false}
          withBorder={false}
          screenReaderLabel={t("dates.increaseMonth")}
          margin="0 0 0 xx-small"
        />
      </div>
    );
  };

  return (
    <DatePicker
      selected={startDate}
      renderCustomHeader={customHeader}
      onChange={(date) => {
        setStartDate(date);
        selectHandler(date);
      }}
      customInput={<ExampleCustomInput id={id} label={label} />}
    />
  );
};
